var _mask, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 100,
    viewBox: "0 0 105 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1404_13779",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 50C0 22.3858 22.3858 0 50 0H52C79.6142 0 102 22.3858 102 50V50C102 77.6142 79.6142 100 52 100H50C22.3858 100 0 77.6142 0 50V50Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 50C0 22.3858 22.3858 0 50 0H52C79.6142 0 102 22.3858 102 50V50C102 77.6142 79.6142 100 52 100H50C22.3858 100 0 77.6142 0 50V50Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H102H0ZM102 100H0H102ZM0 100V0V100ZM55 0C82.6142 0 105 22.3858 105 50C105 77.6142 82.6142 100 55 100H52C77.9574 100 99 77.6142 99 50C99 22.3858 77.9574 0 52 0H55Z",
    fill: "url(#paint0_linear_1404_13779)",
    mask: "url(#path-1-inside-1_1404_13779)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2789 75.9237L51.2892 49.9135L77.1267 75.9237H25.2789Z",
    fill: "url(#paint1_linear_1404_13779)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2789 24.076H51.2892L25.2789 52.1603V24.076Z",
    fill: "url(#paint2_linear_1404_13779)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2892 24.076L25.2789 51.469V75.9238L51.2892 49.9135L77.1267 24.076H51.2892Z",
    fill: "url(#paint3_linear_1404_13779)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1404_13779",
    x1: 51,
    y1: 0,
    x2: 51,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F25823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1404_13779",
    x1: 39.0699,
    y1: 88.0339,
    x2: 63.5657,
    y2: 63.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09677,
    stopColor: "#0095D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3007,
    stopColor: "#238AD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6211,
    stopColor: "#557BDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8643,
    stopColor: "#7472E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#806EE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1404_13779",
    x1: 28.9162,
    y1: 34.4967,
    x2: 43.1434,
    y2: 20.2696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1183,
    stopColor: "#0095D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4178,
    stopColor: "#3C83DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6962,
    stopColor: "#6D74E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8333,
    stopColor: "#806EE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1404_13779",
    x1: 16.5498,
    y1: 71.7447,
    x2: 64.7969,
    y2: 23.4976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1075,
    stopColor: "#C757BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#D0609A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4254,
    stopColor: "#E1725C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6048,
    stopColor: "#EE7E2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#F58613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8232,
    stopColor: "#F88909"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/Android.9876b96421c6dc90ee436518f545cb9d.svg";
export { ForwardRef as ReactComponent };